import { z } from "zod";

export const calculationStepFormSchema = z.object({
  properties: z.array(
    z.object({
      area: z.string({ required_error: "Obrigatório" }).min(1, "Obrigatório"),
      plantedCulture: z
        .string({ required_error: "Obrigatório" })
        .min(1, "Obrigatório"),
      state: z.object({
        label: z.string().min(1),
        value: z.string().min(1),
      }),
      city: z
        .object({
          label: z.string().optional(),
          value: z.string().optional(),
        })
        .optional(),
    })
  ),
});

export type CalculationStepFormValues = z.infer<
  typeof calculationStepFormSchema
>;
